var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJumpToBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.6 30.4l-13.5 13.6c-0.6 0.6-1.6 0.6-2.2 0l-13.5-13.6c-0.6-0.6-0.6-1.6 0-2.2l2.2-2.2c0.6-0.6 1.6-0.6 2.2 0l9.1 9.4c0.6 0.6 1.6 0.6 2.2 0l9.1-9.3c0.6-0.6 1.6-0.6 2.2 0l2.2 2.2c0.5 0.6 0.5 1.5 0 2.1z m0-18.1l-13.5 13.8c-0.6 0.6-1.6 0.6-2.2 0l-13.5-13.8c-0.6-0.6-0.6-1.6 0-2.2l2.2-2.2c0.6-0.6 1.6-0.6 2.2 0l9.1 9.4c0.6 0.6 1.6 0.6 2.2 0l9.1-9.3c0.6-0.6 1.6-0.6 2.2 0l2.2 2.2c0.5 0.6 0.5 1.6 0 2.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpToBottom);
export default __webpack_public_path__ + "static/media/jump_to_bottom.a7caff88f9da298dc57433a996019ce0.svg";
export { ForwardRef as ReactComponent };